export const lang = {
  login: "Login registration", //登录注册
  snedCode: "sned code", //发现音乐
  enterPhone: "Enter phone", //我的音乐
  enterPwd: "Enter password", //我的音乐
  wait: "Wait a moment", //朋友
  errorPhone: "Please enter the correct cell phone number.", //音乐人
  download: "DOWNLOAD" //下载客户端
};
